export { default } from './CureData';
